import { render, staticRenderFns } from "./DownloadCenter.vue?vue&type=template&id=4f5bfc6b&scoped=true"
import script from "./DownloadCenter.vue?vue&type=script&lang=js"
export * from "./DownloadCenter.vue?vue&type=script&lang=js"
import style0 from "./DownloadCenter.vue?vue&type=style&index=0&id=4f5bfc6b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f5bfc6b",
  null
  
)

export default component.exports